const dataTestimonials = [

    {
        img:'testi1',
        entreprise: 'entreprise1',
        content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis asperiores inventore atque sunt dolore quisquam nemo explicabo, laudantium possimus vitae.',
        name: 'Olivia'
    },
    {
        img:'testi2',
        entreprise: 'entreprise2',
        content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis asperiores inventore atque sunt dolore quisquam nemo explicabo, laudantium possimus vitae.',
        name: 'Noah'

    },
    {
        img:'testi3',
        entreprise: 'entreprise3',
        content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis asperiores inventore atque sunt dolore quisquam nemo explicabo, laudantium possimus vitae.',
        name: 'James'

    },
    {
        img:'testi4',
        entreprise: 'entreprise4',
        content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis asperiores inventore atque sunt dolore quisquam nemo explicabo, laudantium possimus vitae.',
        name: 'Harper'

    }

]

export default dataTestimonials